﻿import { Component, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'confirm-modal',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent {
    @Input () show: boolean = false;
    @Input() description: string = "Er du sikker på at du vil udføre denne handling?";

}